const transformTag = (t: string) => {
  if (t === 'shopping') return 'Shops';
  if (t === 'restaurant') return 'Food & Drink';
  if (t === 'lifestyle') return t;
  if (t === 'accommodation') return t;
  if (t === 'services' || t === 'Services') return t;

  return `${t}s`;
};
export default transformTag;
